export function formatDate(date, formatOption) {
    var opt = !formatOption || formatOption === "default" ? "long" : "short";
    return new Intl.DateTimeFormat("en-us", {
        month: opt,
        day: "2-digit",
        year: "numeric",
    }).format(date);
}
//# sourceMappingURL=stringUtils.js.map